/**** mgt.ControllerEquipmentType */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'ControllerEquipmentType',
  title: 'Модели оборудования сотрудников',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'pu_model_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'pu_model_name',
      title: 'Код Наименование',
      type: 'text',
      required: true
    }
  ],
  newTemplate: {
    pu_model_id: null,
    pu_model_name: ''
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'pu_model_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'pu_model_id',
        field: 'pu_model_id',
      },{
        title: 'pu_model_name',
        field: 'pu_model_name',
      }
    ],
    example: `1;Название`,
  }

};

export default config;